import React from 'react';
import styles from './TeamIllustrationAnimation.less';

const TeamMembersImage = require('resources/images/organization/team-members.svg');
const NewTeamMember = require('resources/images/organization/new-team-member.svg');
const WavyBorder = require('resources/images/create-team/wavy-border.svg');

interface TeamIllustrationAnimationProps {
  runAnimation: boolean;
}

export const preloadData = () => {
  new Image().src = TeamMembersImage;
  new Image().src = WavyBorder;
};

export const TeamIllustrationAnimation: React.FunctionComponent<
  TeamIllustrationAnimationProps
> = ({ runAnimation }) => {
  return (
    <div className={styles.illustrationWrapper}>
      <img
        width={342}
        height={256}
        src={TeamMembersImage}
        alt=""
        role="presentation"
      />
      <img
        className={
          !runAnimation ? styles.newMemberHidden : styles.newMemberVisible
        }
        width={50}
        height={50}
        src={NewTeamMember}
        alt=""
        role="presentation"
      />
    </div>
  );
};
